import { render, staticRenderFns } from "./EventsSurvey.vue?vue&type=template&id=23b6d58b&scoped=true&"
import script from "./EventsSurvey.vue?vue&type=script&lang=js&"
export * from "./EventsSurvey.vue?vue&type=script&lang=js&"
import style0 from "./EventsSurvey.vue?vue&type=style&index=0&id=23b6d58b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6d58b",
  null
  
)

export default component.exports